module.exports = __webpack_public_path__ + "static/img/luyinweisha.1d42b1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/luyinweisha.png
// module id = rZKJ
// module chunks = 1